import styled, { css } from 'styled-components'

const OptionSize = 56

export const Container = styled.div`
  position: relative;

  width: 320px;
`

export const ButtonArea = styled.button<{ $loading?: boolean }>`
  padding: 0;
  margin: 0;
  background: none;
  border: 0;

  color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  border-radius: 4px;

  padding: 8px 24px 8px 16px;

  transition: filter 0.3s ease;

  &:hover {
    filter: brightness(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }

  ${({ $loading }) =>
    $loading &&
    css`
      opacity: 0.6;
      cursor: progress;

      &:hover {
        filter: brightness(0.9);
      }
    `}

  .wrap {
    display: flex;
    align-items: center;
    justify-content: start;

    gap: 8px;

    width: 88%;
  }

  .icon {
    width: 38px;
    height: 32px;

    flex-shrink: 0;
    border-radius: 4px;

    object-fit: cover;
  }

  .course-name {
    font-weight: 700;
    font-size: 0.875rem;

    display: inline-block;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    margin: 0;
  }
`

export const Dropdown = styled.div<{ willOverflow: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  z-index: 10;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  border-radius: 4px;

  display: flex;
  flex-direction: column;

  transform: translateY(calc(100% + 6px));

  max-height: ${OptionSize * 3.5}px;

  ${({ willOverflow }) =>
    willOverflow &&
    css`
      overflow-y: scroll;
    `};
`

export const Option = styled.button<{ isSelected: boolean }>`
  position: relative;

  padding: 12px 16px;
  margin: 0;
  background: none;
  border: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  max-width: 100%;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  transition: filter 0.3s ease;

  &:hover {
    filter: brightness(0.96);
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: #e6e6e6;

      background: ${({ theme }) => `rgba(${theme.grayscale[400]}, 0.8)`};
    `}

  .icon {
    width: 38px;
    height: 32px;

    flex-shrink: 0;

    border-radius: 4px;

    object-fit: cover;
  }

  .course-name {
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    font-weight: 700;
    font-size: 0.875rem;

    margin: 0;
    display: inline-block;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    margin-left: 8px;
  }
`
